(function () {
  'use strict';

  document.querySelectorAll('[data-announcement-bar]').forEach(function (bar) {
    var wrapper = bar.parentElement;
    var source = wrapper ? wrapper.querySelector('[data-ab-blocks-source]') : null;
    if (!source) return;

    // Move each block into its declared zone (left / center / right)
    var blocks = Array.prototype.slice.call(source.querySelectorAll(':scope > .ab-block'));
    blocks.forEach(function (block) {
      var zone = block.getAttribute('data-group') || 'center';
      var target = bar.querySelector('.announcement-bar__group[data-zone="' + zone + '"]');
      if (target) target.appendChild(block);
    });
    source.remove();

    // Marquee speed
    bar.querySelectorAll('.ab-marquee').forEach(function (m) {
      var speed = m.getAttribute('data-speed') || 20;
      m.style.setProperty('--ab-marquee-duration', speed + 's');
    });

    // Countdown timers
    bar.querySelectorAll('[data-timer]').forEach(function (timerEl) {
      var countdown = timerEl.closest('.ab-countdown');
      var end = new Date(countdown.getAttribute('data-end')).getTime();
      if (isNaN(end)) return;

      function tick() {
        var now = Date.now();
        var diff = end - now;
        if (diff <= 0) {
          timerEl.textContent = '00:00:00';
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var mnt = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        var pad = function (n) { return String(n).padStart(2, '0'); };
        timerEl.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(mnt) + ':' + pad(s);
        requestAnimationFrame(function () { setTimeout(tick, 1000); });
      }
      tick();
    });

    // Dismiss / close button, persisted per-browser via localStorage
    if (bar.getAttribute('data-dismissible') === 'true') {
      var key = bar.getAttribute('data-dismiss-key');
      try {
        if (key && localStorage.getItem(key) === '1') {
          bar.setAttribute('data-dismissed', '');
        }
      } catch (e) { /* localStorage unavailable, fail open */ }

      var closeBtn = bar.querySelector('[data-ab-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          bar.setAttribute('data-dismissed', '');
          try { if (key) localStorage.setItem(key, '1'); } catch (e) { }
        });
      }
    }
  });
})();
